import { getDate, getDay, getMonth as getMonthNumber, parse } from 'date-fns'
import ordinal from 'ordinal'

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

/**
 * Returns the month string (ie "January") from a given Date
 * @param {Date} date
 * @return {string}
 */
export const getMonth = (date?: Date): string => {
    if (!date) {
        return ''
    }

    const monthNumber: number = getMonthNumber(date)

    if (monthNumber > 11) {
        console.error('Cannot resolve getMonth for:', monthNumber, 'from', date)
        return ''
    }

    return months[monthNumber]
}

const days = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
]

/**
 * Returns the day string (ie "Monday") from a given Date
 * @param {Date} date
 * @return {string}
 */
export const getDayOfWeek = (date?: Date): string => {
    if (!date) {
        return ''
    }

    const dayNumber: number = getDay(date)

    if (dayNumber > 6) {
        console.error('Cannot resolve getDayOfWeek for:', dayNumber, 'from', date)
        return ''
    }

    return days[dayNumber]
}

/**
 * Returns the ordinal day (ie "1st", "11th", or "23rd") from a given Date
 * @param {Date} date
 * @return {string}
 */
export const getOrdinalDay = (date?: Date): string => {
    if (!date) {
        return ''
    }

    return ordinal(getDate(date))
}

// parseDate returns a javascript Date object from a YYYY-MM-DD string input (ie "2022-03-09")
export const parseDate = (date: string): Date => {
    return parse(date, 'yyyy-MM-dd', new Date())
}
